import React from 'react'
import Footer from '../../navigation/Footer'

function ScanedLocation() {
    return (
        <>
        ScanedLocation
        <Footer/>
        </>
    )
}

export default ScanedLocation